var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 0.5H4.25C1.85938 0.5 0 2.42578 0 4.75V21.75C0 24.1406 1.85938 26 4.25 26H29.75C32.0742 26 34 24.1406 34 21.75V4.75C34 2.42578 32.0742 0.5 29.75 0.5ZM4.25 3.6875H29.75C30.2812 3.6875 30.8125 4.21875 30.8125 4.75V6.27734L19.7227 15.5078C18.1953 16.7695 15.7383 16.7695 14.2109 15.5078L3.1875 6.27734V4.75C3.1875 4.21875 3.65234 3.6875 4.25 3.6875ZM29.75 22.8125H4.25C3.65234 22.8125 3.1875 22.3477 3.1875 21.75V10.3945L12.2188 17.9648C13.5469 19.0273 15.207 19.6914 17 19.6914C18.7266 19.6914 20.3867 19.0273 21.7148 17.9648L30.8125 10.3945V21.75C30.8125 22.3477 30.2812 22.8125 29.75 22.8125Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1ec579b3b14d779dc927bae7fcade04a.svg";
export { ForwardRef as ReactComponent };